
import React from 'react';

interface QuizAttemptInfoProps {
  attemptNumber: number;
  maxAttempts: number | null;
  totalAvailablePoints: number;
}

const QuizAttemptInfo: React.FC<QuizAttemptInfoProps> = ({
  attemptNumber,
  maxAttempts,
  totalAvailablePoints
}) => {
  return (
    <>
      {maxAttempts && (
        <div className="text-sm text-muted-foreground">
          Poging {attemptNumber} van {maxAttempts}
        </div>
      )}
      
      <div className="text-sm text-muted-foreground italic">
        Je moet 100% score behalen om verder te kunnen gaan ({totalAvailablePoints} punten)
      </div>
    </>
  );
};

export default QuizAttemptInfo;
